
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M486.3 267.6L332 421.9h156.3c3.3 0 6 1.1 8.3 3.4s3.4 5 3.4 8.3V457c0 3.3-1.1 6-3.4 8.3s-5 3.4-8.3 3.4H140.6c-13 0-24.1-4.6-33.2-13.7l-93.8-93.8c-9-9-13.6-20.1-13.6-33.1s4.6-24.1 13.7-33.2l250-250c9.1-9.1 20.2-13.7 33.2-13.7s24.1 4.6 33.2 13.7l156.3 156.3c9.1 9.1 13.7 20.2 13.7 33.2s-4.7 24.1-13.8 33.2zM140.6 421.9h125l53.7-53.7-156.2-156.3L46.9 328.1l93.7 93.8zM296.9 78.1L196.3 178.7 352.5 335l100.6-100.6L296.9 78.1z"}})])
          )
        }
      }
    